import axios, { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { GET_CONTACTINFO } from '../../helpers/constants';
import { request } from '../../helpers/request';

export const getContactInfo = (dispatch: Dispatch) => {
    return request
        .getContactInfo()
        .then((response: AxiosResponse) => {
            dispatch({
                type: GET_CONTACTINFO,
                payload: response.data?.contactInformation
            });
        })

        .catch((err: AxiosError | Error) => {
            if (axios.isAxiosError(err)) {
                console.log(err.response?.data);
            } else {
                console.log(err.message);
            }
        });
};
